var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21659 0.175667C8.32907 0.28818 8.39226 0.440761 8.39226 0.599855C8.39226 0.758949 8.32907 0.911529 8.21659 1.02404L3.41673 5.82391C3.30422 5.93639 3.15164 5.99957 2.99254 5.99957C2.83345 5.99957 2.68087 5.93639 2.56835 5.82391L0.168422 3.42397C0.0591305 3.31082 -0.00134433 3.15926 2.26809e-05 3.00195C0.00138969 2.84463 0.0644893 2.69415 0.175731 2.58291C0.286973 2.47167 0.437456 2.40857 0.594769 2.4072C0.752083 2.40583 0.90364 2.46631 1.0168 2.5756L2.99254 4.55134L7.36822 0.175667C7.48073 0.0631875 7.63331 0 7.7924 0C7.9515 0 8.10408 0.0631875 8.21659 0.175667Z",
    fill: "#052844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e1faf3da9a5029dc344eef2deba4e525.svg";
export { ForwardRef as ReactComponent };